import { createSlice } from '@reduxjs/toolkit';
import { CommonState, setIsResetUploadFileInputErrorMessageAction } from './types';

const initialState: CommonState = {
  isResetUploadFileInputErrorMessage: false,
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsResetUploadFileInputErrorMessage: (
      state,
      action: setIsResetUploadFileInputErrorMessageAction
    ) => {
      state.isResetUploadFileInputErrorMessage = action.payload;
    },
  },
});

export const { reducer: commonReducer, actions: commonActions } = commonSlice;
